import React from 'react';
import { Container, Row, Col, Image, ListGroup } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import Blog6 from '../Components/img/Blog6.webp'; // Image import

const SelfCareMentalHealth = () => {
  return (
    <Container className="py-5">
      {/* ✅ SEO Optimized Meta Tags */}
      <Helmet>
        <title>Self-Care Tips for Mental Health | Best Strategies</title>
        <meta name="description" content="Discover the best self-care tips for mental health, including mindfulness, physical activities, healthy diet, sleep, and stress management." />
        <meta name="keywords" content="Self-care, Mental Health, Stress Relief, Mindfulness, Healthy Diet, Sleep, Relaxation" />
        <meta name="author" content="Dr. Swati Chavhan" />
        <meta property="og:title" content="Self-Care Tips for Mental Health | Best Strategies" />
        <meta property="og:description" content="Learn how to take care of your mental health with effective self-care strategies, including mindfulness, exercise, and a healthy lifestyle." />
        <meta property="og:image" content="https://drswatichavhanpsychiatrist.com/path-to-Blog6.webp" />
        <meta property="og:url" content="https://drswatichavhanpsychiatrist.com/self-care-mental-health" />
        <meta property="og:type" content="article" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Row className="align-items-center">
        <Col md={6}>
          <h1 className="text-dark">Self-Care Tips for Mental Health</h1>
          <p className="text-muted">
            Taking care of your mental health is just as important as maintaining physical health. 
            A good self-care routine helps in reducing stress, improving emotional resilience, and promoting overall well-being.
          </p>
          <Image src={Blog6} alt="Self-Care Tips for Mental Health" fluid className="rounded shadow" />
        </Col>

        <Col md={6}>
          <h2 className="text-dark mt-4">Effective Self-Care Strategies:</h2>
          <ListGroup variant="flush" className="mt-3">
            <ListGroup.Item>✅ <strong>Practice Mindfulness:</strong> Stay present and reduce stress.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Engage in Physical Activities:</strong> Exercise releases endorphins, boosting mood.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Maintain a Healthy Diet:</strong> Proper nutrition supports mental clarity and energy.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Prioritize Sleep:</strong> Quality sleep is essential for mental rejuvenation.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Take Breaks & Unplug:</strong> Avoid burnout by setting aside time for relaxation.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Seek Support:</strong> Connect with loved ones or professional counselors.</ListGroup.Item>
          </ListGroup>

          <p className="text-muted mt-3">
            By incorporating these <strong>self-care strategies</strong>, you can achieve a <strong>healthier mind, balanced emotions</strong>, and a <strong>happier life</strong>.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default SelfCareMentalHealth;
